'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var log = require('./logger');
var _ = require('../mindash');

var StoreObserver = (function () {
  function StoreObserver(options) {
    var _this = this;

    _classCallCheck(this, StoreObserver);

    options = options || {};

    this.app = options.app;
    this.component = options.component;
    this.onStoreChanged = options.onStoreChanged || _.noop;

    var stores = resolveStores(options);

    this.listeners = _.map(stores, function (store) {
      return _this.listenToStore(store);
    });
  }

  _createClass(StoreObserver, [{
    key: 'dispose',
    value: function dispose() {
      _.invoke(this.listeners, 'dispose');
    }
  }, {
    key: 'listenToStore',
    value: function listenToStore(store) {
      var _this2 = this;

      var component = this.component;
      var storeDisplayName = store.displayName || store.id;

      log.trace('The ' + component.displayName + ' component  (' + component.id + ') is listening to the ' + storeDisplayName + ' store');

      return store.addChangeListener(function (state, store) {
        var storeDisplayName = store.displayName || store.id;

        log.trace(storeDisplayName + ' store has changed. ' + ('The ' + _this2.component.displayName + ' component (' + _this2.component.id + ') is updating'));

        if (store && store.action) {
          store.action.addComponentHandler({
            displayName: _this2.component.displayName
          }, store);
        }

        _this2.onStoreChanged(store);
      });
    }
  }]);

  return StoreObserver;
})();

function resolveStores(options) {
  var app = options.app;
  var stores = options.stores;

  if (stores && !_.isArray(stores)) {
    stores = [stores];
  }

  return _.map(stores, function (storeId) {
    if (!_.isString(storeId)) {
      throw new Error('Store Id\'s must be strings. If you\'re migrating to v0.10 ' + 'you have probably forgotten to update listenTo');
    }

    if (!app) {
      throw new Error('Component not bound to an application');
    }
    var store = _.get(app, storeId, null);
    if (!store) {
      throw new Error('Could not find the store ' + storeId);
    }

    return store;
  });
}

module.exports = StoreObserver;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/storeObserver.js
 ** module id = 231
 ** module chunks = 0
 **/